export default {
  "confirmBookingView.agency": "Agencia",
  "confirmBookingView.discount": "Descuento",
  "confirmBookingView.subtotal": "Subtotal",
  "confirmBookingView.total": "Total",
};
